import { BoldText } from "components/markdown-text";
import React from "react";
import { Text, TouchableOpacity } from "react-native";

import { styles } from "./styles";

export const Tile = ({ text, style, textStyle, onPress, isSelected }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.tile, isSelected && styles.tileSelected, style]}
    >
      <Text style={[styles.text, isSelected && styles.textSelected, textStyle]}>
        <BoldText>{text}</BoldText>
      </Text>
    </TouchableOpacity>
  );
};
